import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Principal } from '../models/principal';
import { BaseResponse } from '../models/base-response';
import { PrincipalService } from '../services/principal.service';

@Component({
  selector: 'app-fetch-data',
  templateUrl: './fetch-data.component.html'
})

export class FetchDataComponent implements OnInit {
  public forecasts: WeatherForecast[];
  public principal: Principal[] = [];

  constructor(private principalService: PrincipalService) { }

  ngOnInit() {
    this.principal = this.principalService.getPrincipalHighlighted(
      (data) => {
      this.principal = data;
    },
    err => {
      console.log(err);
    });
  }
}

interface WeatherForecast {
  dateFormatted: string;
  temperatureC: number;
  temperatureF: number;
  summary: string;
}
